export const POPUP_ID = 'popup/POPUP_ID';
